import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/** Inline "Add skill" affordance used in the template editor's skill surfaces. */
export const AddSkillButton = ({ onClick }: { onClick: () => void }) => (
  <button
    type="button"
    data-add-skill
    onClick={onClick}
    className="group/add-skill mr-1 flex flex-row items-center justify-center gap-1 text-gray-6 transition-transform hover:scale-110"
  >
    <FontAwesomeIcon
      icon={faCirclePlus}
      className="h-4 w-4 transition-transform duration-200 group-hover/add-skill:scale-125"
    />
    <span className="text-xs">Add skill</span>
  </button>
);
